module.exports = [{"name":"类别","value":""},{"name":"写字楼","value":"写字楼"},{"name":"商铺独楼","value":"商铺独楼"},{"name":"商务中心","value":"商务中心"},{"name":"商住公寓","value":"商住公寓"},{"name":"产业园","value":"产业园"},{"name":"酒店","value":"酒店"},{"name":"购物中心","value":"购物中心"},{"name":"待认领","value":"empty"},{"name":"私有","value":"private"}]


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/data/building_type.json
// module id = t1X8
// module chunks = 38